
webpack.register(
    'modules/qualification-drawer/qualification-drawer',
    function() {
        return import('modules/qualification-drawer/qualification-drawer');
    },
    true
);